import {createContext} from 'react';

import {ConfirmationDialogCtxProps} from '../types/ConfirmationDialogCtxProps';

export const ConfirmationDialogCtx = createContext<ConfirmationDialogCtxProps>(
  {} as ConfirmationDialogCtxProps
);
